import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
    const token = localStorage.getItem("PhilomenaAdminToken");

    const isAuthenticated =
        !!token && token !== "undefined" && token !== "null";

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PublicRoute;
